import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'

const GRAPHCMS_API = 'https://api-euwest.graphcms.com/v1/cjvwbdhvw7ift01et86ru6o1s/master' // URL für CMS-Schnittstelle
const GRAPHCMS_AUTH = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ2ZXJzaW9uIjoxLCJ0b2tlbklkIjoiZGI2NDgwMzktYzViOC00MDJhLTg5OWItMzU1YWM3ODcwODBkIn0.q2y3ukXgNMsw0SztSbO6Pm2_rZCy5g6jQBiSA1EvFdk' // API-Key für den Zugriff auf die Schnittstelle

export default ({ app }) => {
  const httpLink = createHttpLink({
    uri: GRAPHCMS_API,
  })

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: `Bearer ${GRAPHCMS_AUTH}`,
      locale: app.i18n.locale.toUpperCase(),
    },
  }))

  return {
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultHttpLink: false,
  }
}
